import {PollDetails} from '~/features/Polls/PollDetails';

export const PollDetailsScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <a href="/polls" className="btn m-4">
        Back to Polls
      </a>
      <br />
      <PollDetails />
    </div>
  );
};
